import { lazy } from 'react';

export const MedOrgDetailsPageAsync = lazy(
  () => import('./MedOrgDetailsPage.tsx'),
);
